
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerEditor()
    export class IcStockReturnOutEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, IcStockReturnOutRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return IcStockReturnOutRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
